import closeButton from '@/components/generics/close-button/close-button.vue';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    silent: {
      type: Boolean,
      default: false,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    returnRoute: {
      type: String,
    },
    returnRouteGoTo: {
      type: String,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  components: {
    closeButton,
  },
  computed: {
    classModifiers() {
      return {
        'content-header': true,
        [`content-header--${this.theme}`]: this.theme,
      };
    },
  },
  methods: {
    close() {
      this.$emit('close');
      if (this.silent) return;
      if (this.returnRoute) {
        const routeObj = { name: this.returnRoute };
        if (this.returnRouteGoTo) {
          routeObj.query = { el: this.returnRouteGoTo };
        }
        this.$router.push(routeObj);
      } else {
        this.$router.go(-1);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/content-header/content-header.js